// extracted by mini-css-extract-plugin
export default {"nav":"AuthNavigation_nav__7WCoV","link":"AuthNavigation_link__eLg7D","current":"AuthNavigation_current__UyZ5p"};